import { useTranslation } from 'react-i18next';
import './RatingButtons.css';

const RATINGS = [
  { value: 1, key: 'again', className: 'rating-again' },
  { value: 2, key: 'hard', className: 'rating-hard' },
  { value: 3, key: 'good', className: 'rating-good' },
  { value: 4, key: 'easy', className: 'rating-easy' },
];

export default function RatingButtons({ onRate, disabled }) {
  const { t } = useTranslation();

  return (
    <div className="rating-buttons">
      {RATINGS.map(({ value, key, className }) => (
        <button
          key={value}
          className={`rating-btn ${className}`}
          onClick={() => onRate(value)}
          disabled={disabled}
        >
          {t(`learn.session.${key}`)}
        </button>
      ))}
    </div>
  );
}
